module.exports = __webpack_public_path__ + "static/media/basketball-ball.6ae3c747.svg";